export const EnvConfigs = {
    REACT_APP_API_URL: "https://booksez-qa.azurewebsites.net/api/v",
    version: 1
}